$(window).on('resize',function() {
	if ($(window).width() > 1023) {
		$('.js-readonly').prop('readonly', true);
	} 
	
	if ($(window).width() <= 1023) {
		$('.js-readonly').prop('readonly', false);
	}
});

if ($(window).width() <= 1023) {
	$('.js-readonly').prop('readonly', false);
}


// WEBPACK FOOTER //
// ./src/js/pages/materials/input-work.js